import React from 'react';

import './styles.css';

export default function ConnectingView() {
	
	return (
		<div className="login-container">
			<div className="container">
				<div id="login">
					<h2>
						<span className="header ubuntu"><span className="fa fa-cs-logo fa-spin"></span>{PRODUCT_NAME} - connecting...</span>
					</h2>
				</div>
			</div>
		</div>
	);
}